
import moment from 'moment';
import { Input, AutoComplete, Button, Col, Form, Icon, Row, Spin, Table } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getStringSorter, getBooleanSorter } from '../utils/antUtils';
import { getPageSize } from '../utils/paging';
import styles from './newsentry.css';
import { fetchNewsEntries, editNewsEntry, filter, filterDb } from './newsentryActions';
import NewsEntryModal from './newsentryModalComponent';
import Highlight from '../components/highlightComponent'
import { ENV } from '../utils/http'

const { Column } = Table;


class NewsEntryComponent extends Component {

  componentDidMount() {
    this.props.dispatch(fetchNewsEntries(this.props.match.params.id));    
  }

  onFilter = (query) => {
    this.props.dispatch(filter(query))
  }

  onFilterDb = (query) => {
    this.props.dispatch(filterDb(query))
  }

  newNewsEntry = () => {
    let newsentry = { id: -1, title: '', content: '', publishedOnStartPage: true, lawEntry: false, publishedDateString: moment().format("YYYY-MM-DD"), dbType: '' };
    this.props.dispatch(editNewsEntry(newsentry));
  }

  preview = (newsEntry, e) =>{
    e.preventDefault();
    e.stopPropagation();
  
    window.open(`${ENV.previewUrl}/nyhet/${newsEntry}`, '_blank');
  }

  render() {
    let data = this.props.list || [];
    const onRow = (edit) => ({
      onClick: () => {
        let clone = Object.assign({}, edit)
        this.props.dispatch(editNewsEntry(clone));
      }
    });

    let lowerCaseFilter = this.props.filter ? this.props.filter.toLowerCase() : '';
    let lowerCaseFilterDb = this.props.filterDb ? this.props.filterDb.toLowerCase() : '';

    let compare = (a, attr, filterQuery) => (a[attr] || '').toLowerCase().indexOf(filterQuery) >= 0;

    data = !lowerCaseFilter ? data : data.filter((newsentry) => {
      return compare(newsentry, 'title', lowerCaseFilter) || compare(newsentry, 'publishedDateString', lowerCaseFilter)
    });

    data = !lowerCaseFilterDb ? data : data.filter((newsentry) => {
      return compare(newsentry, 'dbType', lowerCaseFilterDb)
    });

    let filteredCount = data.length;

    const renderPreviewButton = (newsEntry) => <Button onClick={(e) => this.preview(newsEntry, e)}>Förhandsgranska</Button>

    return (<div>

      <NewsEntryModal />      

      <Row style={styles.toolbar}>
        <Col span={6}>
          <AutoComplete
            style={{ width: '100%' }}
            dataSource={[]}
            onSearch={this.onFilter}
            value={this.props.filter}
            placeholder="Filtrera på titel eller datum"
          >
            <Input suffix={<Icon type="filter" />} />
          </AutoComplete>
        </Col>
        <Col span={4}>
          <AutoComplete
            style={{ width: '100%' }}
            dataSource={[]}
            onSearch={this.onFilterDb}
            value={this.props.filterDb}
            placeholder="Filtrera på databas"
          >
            <Input suffix={<Icon type="filter" />} />
          </AutoComplete>
        </Col>
        <Col span={2}>
          <div style={{ padding: 5 }}>{filteredCount} {filteredCount === 1 ? 'träff' : 'träffar'}</div>
        </Col>
        <Col span={12}>
        <Button type='primary' icon='plus' size='large' onClick={this.newNewsEntry} style={{ float: 'right' }}>Ny nyhet</Button>
        </Col>
      </Row>

      <Spin spinning={this.props.loading}>
        <Table dataSource={data} size='small' pagination={{ pageSize: getPageSize(), position: 'bottom' }} onRow={onRow} style={styles.table} >
        <Column title="Titel" defaultSortOrder='ascend' width={700} dataIndex="title" key="title" sorter={getStringSorter('title')}
            render={text => (<Highlight text={text} query={lowerCaseFilter} />)} />

          <Column title="Publiceringsdatum" dataIndex="publishedDateString" key="publishedDateString" render={text => (<Highlight text={text} query={lowerCaseFilter} />)} sorter={getStringSorter('publishedDateString')} />
          <Column title="Publicerad" dataIndex="publishedOnStartPage" key="publishedOnStartPage" sorter={getBooleanSorter('publishedOnStartPage')} render={ value => value? 'Ja' : 'Nej'} />
          <Column title="Lagnyhet" dataIndex="lawEntry" key="lawEntry" sorter={getBooleanSorter('lawEntry')} render={ value => value? 'Ja' : 'Nej'} />
          <Column title="Sortering" dataIndex="sortOrder" key="sortOrder" />
          <Column title="Databaser" width={150} dataIndex="dbType" render={text => (<Highlight text={text} query={lowerCaseFilterDb} />)} key="dbType" sorter={getStringSorter('dbType')} />
          <Column title="Förhandsgranska" dataIndex="id" key="id" render={(newsEntry) => renderPreviewButton(newsEntry)} />
          
        </Table>
      </Spin>

      

    </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    list: state.newsentry.list,
    loading: state.newsentry.loading,
    filter: state.newsentry.filter,
    filterDb: state.newsentry.filterDb,
  }
};

export default connect(mapStateToProps)(Form.create()(NewsEntryComponent));


// WEBPACK FOOTER //
// ./src/newsentry/newsentryComponent.js